
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from "moment";

export const RoadMasterExportWorkName = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />
            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '80%' }}>

                <h5><span>&emsp;</span></h5>

                <tr>
                    <th colSpan={6} style={{ textAlign: 'center', fontSize: 16, border: '1px solid black' }}>{name}</th>
                </tr>

                {/* <tr><td></td></tr> */}

                <thead className="thead-dark" >
                    <tr style={{ backgroundColor: '#254462', color: "#fff" }}>
                        <th style={{ borderLeft: "1px solid black" }}>Sr.No.</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Type</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Name</th>
                        <th style={{ borderLeft: "1px solid white" }}>BenchMark (Days)</th>
                        <th style={{ borderLeft: "1px solid white" }}>Penalty Description</th>
                        <th style={{ borderLeft: "1px solid white" }}>Penalty Amount (Rs.)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item, i) => (
                            <tr style={{ textAlign: "center", border: '1px solid black' }}>
                                <td>{item.rowNum}</td>
                                <td style={{ textAlign: "left" }}>{item.heading ? item.heading : '-'}</td>
                                <td style={{ textAlign: "left" }}>{item.workName ? item.workName : '-'}</td>
                                <td>{item.benchMark ? item.benchMark : '-'}</td>
                                <td style={{ textAlign: "left" }}>{item.penalty_Description ? item.penalty_Description : '-'}</td>
                                <td style={{ textAlign: "right" }}>{item.penalty_Values ? (item.penalty_Values).toFixed(2) : '-'}</td>

                            </tr>
                        )) : <tr>No data</tr>
                    }
                </tbody>
            </table>
        </div>
    )
}